import axios from "axios";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { getAuthToken } from "utils/authUtils";

const PPC_REQUIRED_SURVEY_CODE = "2F2L";

type CecSurvey = {
  code: string;
  name?: string;
};

type CecResponse = {
  surveys?: CecSurvey[];
};

const toolboxApiUrl =
  getEnvironment() === "production"
    ? "https://designtools.sunrun.com/api"
    : "https://devdesigntools.sunrun.com/api";

const isPpcRequired = (response: CecResponse): boolean =>
  response.surveys?.some(
    (survey) => survey.code === PPC_REQUIRED_SURVEY_CODE
  ) ?? false;

const getCecEligibility = async (lookupId: string): Promise<boolean> => {
  const token = await getAuthToken();
  const response = await axios.get<CecResponse>(
    `${toolboxApiUrl}/v1/cec/${lookupId}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );

  return isPpcRequired(response.data);
};

export {
  getCecEligibility,
  isPpcRequired,
  PPC_REQUIRED_SURVEY_CODE,
  toolboxApiUrl,
};
export type { CecResponse, CecSurvey };
